import type { FunctionComponent, SVGProps } from 'react';

import MapSvgImage from './images/map.svg';
import { ReactComponent as BackImageComponent } from './images/back.svg';
import { ReactComponent as NextImageComponent } from './images/next.svg';
import { ReactComponent as CloseImageComponent } from './images/close.svg';
import SpeechBubbleSmallSvgImage from './images/speechBubbleSmall.svg';
import SpeechBubbleLargeSvgImage from './images/speechBubbleLarge.svg';
import { ReactComponent as PointerImageComponent } from './images/pointer.svg';
import { ReactComponent as CheckedImageComponent } from './images/checked.svg';
import { ReactComponent as PlusImageComponent } from './images/plus.svg';
import { ReactComponent as SettingsImageComponent } from './images/settings.svg';
import { ReactComponent as VolumeLowImageComponent } from './images/volumeLow.svg';
import { ReactComponent as VolumeHighImageComponent } from './images/volumeHigh.svg';
// Seasons
import { ReactComponent as SpringImageComponent } from './images/seasons/spring.svg';
import { ReactComponent as SummerImageComponent } from './images/seasons/summer.svg';
import { ReactComponent as FallImageComponent } from './images/seasons/fall.svg';
import { ReactComponent as WinterImageComponent } from './images/seasons/winter.svg';
// Score
import { ReactComponent as EnvironmentImageComponent } from './images/score/environment.svg';
import { ReactComponent as QualityOfLifeImageComponent } from './images/score/qualityOfLife.svg';
import { ReactComponent as HappinessImageComponent } from './images/score/happiness.svg';
// Personas
import { ReactComponent as EllenBodyImageComponent } from './images/personas/body/body.ellen.svg';
import { ReactComponent as EllenInterestedBodyImageComponent } from './images/personas/body/body.ellen.interested.svg';
import { ReactComponent as EllenSkepticalBodyImageComponent } from './images/personas/body/body.ellen.skeptical.svg';
import { ReactComponent as EllenAmazedBodyImageComponent } from './images/personas/body/body.ellen.amazed.svg';
import { ReactComponent as EllenAmazed2BodyImageComponent } from './images/personas/body/body.ellen.amazed2.svg';
import { ReactComponent as ProponentBodyImageComponent } from './images/personas/body/body.proponent.svg';
import { ReactComponent as OpponentBodyImageComponent } from './images/personas/body/body.opponent.svg';
import { ReactComponent as AischeFacePositiveImageComponent } from './images/personas/face/face.aische.positive.svg';
import { ReactComponent as AischeFaceNegativeImageComponent } from './images/personas/face/face.aische.negative.svg';
import { ReactComponent as AischeBodyPositiveImageComponent } from './images/personas/body/body.aische.positive.svg';
import { ReactComponent as AischeBodyNegativeImageComponent } from './images/personas/body/body.aische.negative.svg';
import { ReactComponent as BenFacePositiveImageComponent } from './images/personas/face/face.ben.positive.svg';
import { ReactComponent as BenFaceNegativeImageComponent } from './images/personas/face/face.ben.negative.svg';
import { ReactComponent as BenBodyPositiveImageComponent } from './images/personas/body/body.ben.positive.svg';
import { ReactComponent as BenBodyNegativeImageComponent } from './images/personas/body/body.ben.negative.svg';
import { ReactComponent as HelgaFacePositiveImageComponent } from './images/personas/face/face.helga.positive.svg';
import { ReactComponent as HelgaFaceNegativeImageComponent } from './images/personas/face/face.helga.negative.svg';
import { ReactComponent as HelgaBodyPositiveImageComponent } from './images/personas/body/body.helga.positive.svg';
import { ReactComponent as HelgaBodyNegativeImageComponent } from './images/personas/body/body.helga.negative.svg';
import { ReactComponent as HorstFacePositiveImageComponent } from './images/personas/face/face.horst.positive.svg';
import { ReactComponent as HorstFaceNegativeImageComponent } from './images/personas/face/face.horst.negative.svg';
import { ReactComponent as HorstBodyPositiveImageComponent } from './images/personas/body/body.horst.positive.svg';
import { ReactComponent as HorstBodyNegativeImageComponent } from './images/personas/body/body.horst.negative.svg';
import { ReactComponent as LeonFacePositiveImageComponent } from './images/personas/face/face.leon.positive.svg';
import { ReactComponent as LeonFaceNegativeImageComponent } from './images/personas/face/face.leon.negative.svg';
import { ReactComponent as LeonBodyPositiveImageComponent } from './images/personas/body/body.leon.positive.svg';
import { ReactComponent as LeonBodyNegativeImageComponent } from './images/personas/body/body.leon.negative.svg';
import { ReactComponent as MaxiFacePositiveImageComponent } from './images/personas/face/face.maxi.positive.svg';
import { ReactComponent as MaxiFaceNegativeImageComponent } from './images/personas/face/face.maxi.negative.svg';
import { ReactComponent as MaxiBodyPositiveImageComponent } from './images/personas/body/body.maxi.positive.svg';
import { ReactComponent as MaxiBodyNegativeImageComponent } from './images/personas/body/body.maxi.negative.svg';
import { ReactComponent as MelFacePositiveImageComponent } from './images/personas/face/face.mel.positive.svg';
import { ReactComponent as MelFaceNegativeImageComponent } from './images/personas/face/face.mel.negative.svg';
import { ReactComponent as MelBodyPositiveImageComponent } from './images/personas/body/body.mel.positive.svg';
import { ReactComponent as MelBodyNegativeImageComponent } from './images/personas/body/body.mel.negative.svg';
import { ReactComponent as PeteFacePositiveImageComponent } from './images/personas/face/face.pete.positive.svg';
import { ReactComponent as PeteFaceNegativeImageComponent } from './images/personas/face/face.pete.negative.svg';
import { ReactComponent as PeteBodyPositiveImageComponent } from './images/personas/body/body.pete.positive.svg';
import { ReactComponent as PeteBodyNegativeImageComponent } from './images/personas/body/body.pete.negative.svg';
import { ReactComponent as SamiraFacePositiveImageComponent } from './images/personas/face/face.samira.positive.svg';
import { ReactComponent as SamiraFaceNegativeImageComponent } from './images/personas/face/face.samira.negative.svg';
import { ReactComponent as SamiraBodyPositiveImageComponent } from './images/personas/body/body.samira.positive.svg';
import { ReactComponent as SamiraBodyNegativeImageComponent } from './images/personas/body/body.samira.negative.svg';
// Concepts
// Concepts - Icons
import { ReactComponent as CoworkingImageComponent } from './images/concepts/coworking.svg';
import { ReactComponent as ShowersImageComponent } from './images/concepts/showers.svg';
import { ReactComponent as Speedlimit20ImageComponent } from './images/concepts/speedlimit20.svg';
import { ReactComponent as FishiesImageComponent } from './images/concepts/fishies.svg';
import { ReactComponent as ElectricCarChargersImageComponent } from './images/concepts/electricCarChargers.svg';
import { ReactComponent as ParcelShopsImageComponent } from './images/concepts/parcelShops.svg';
import { ReactComponent as ParkingSharedImageComponent } from './images/concepts/parkingShared.svg';
import { ReactComponent as MobilityStationsImageComponent } from './images/concepts/mobilityStations.svg';
import { ReactComponent as ParkingCarReducedImageComponent } from './images/concepts/parkingCarReduced.svg';
import { ReactComponent as CarSharingImageComponent } from './images/concepts/carSharing.svg';
import { ReactComponent as ParkingBikeIncreasedImageComponent } from './images/concepts/parkingBikeIncreased.svg';
import { ReactComponent as BikeSwarmImageComponent } from './images/concepts/bikeSwarm.svg';
// Concepts - Overlays
import ParkingCarReducedActiveOverlaySvgImage from './images/concepts/overlay/parkingCarReduced.active.svg';
import ParkingCarReducedInactiveOverlaySvgImage from './images/concepts/overlay/parkingCarReduced.inactive.svg';
import Speedlimit20ActiveOverlaySvgImage from './images/concepts/overlay/speedlimit20.active.svg';
import ParkingBikeIncreasedActiveOverlaySvgImage from './images/concepts/overlay/parkingBikeIncreased.active.svg';
import CoworkingActiveOverlaySvgImage from './images/concepts/overlay/coworking.active.svg';
import ShowersActiveOverlaySvgImage from './images/concepts/overlay/showers.active.svg';
import ParcelShopsActiveOverlaySvgImage from './images/concepts/overlay/parcelShops.active.svg';
import ElectricCarChargersActiveOverlaySvgImage from './images/concepts/overlay/electricCarChargers.active.svg';
import MobilityStationsActiveOverlaySvgImage from './images/concepts/overlay/mobilityStations.active.svg';
// Concepts - Effects
import { ReactComponent as CoworkingBeforeImageComponent } from './images/concepts/effects/coworking.before.svg';
import { ReactComponent as CoworkingAfterImageComponent } from './images/concepts/effects/coworking.after.svg';
import { ReactComponent as ShowersBeforeImageComponent } from './images/concepts/effects/showers.before.svg';
import { ReactComponent as ShowersAfterImageComponent } from './images/concepts/effects/showers.after.svg';
import { ReactComponent as Speedlimit20BeforeImageComponent } from './images/concepts/effects/speedlimit20.before.svg';
import { ReactComponent as Speedlimit20AfterImageComponent } from './images/concepts/effects/speedlimit20.after.svg';
import { ReactComponent as FishiesBeforeImageComponent } from './images/concepts/effects/fishies.before.svg';
import { ReactComponent as FishiesAfterImageComponent } from './images/concepts/effects/fishies.after.svg';
import { ReactComponent as ElectricCarChargersBeforeImageComponent } from './images/concepts/effects/electricCarChargers.before.svg';
import { ReactComponent as ElectricCarChargersAfterImageComponent } from './images/concepts/effects/electricCarChargers.after.svg';
import { ReactComponent as ParcelShopsBeforeImageComponent } from './images/concepts/effects/parcelShops.before.svg';
import { ReactComponent as ParcelShopsAfterImageComponent } from './images/concepts/effects/parcelShops.after.svg';
import { ReactComponent as ParkingSharedBeforeImageComponent } from './images/concepts/effects/parkingShared.before.svg';
import { ReactComponent as ParkingSharedAfterImageComponent } from './images/concepts/effects/parkingShared.after.svg';
import { ReactComponent as MobilityStationsBeforeImageComponent } from './images/concepts/effects/mobilityStations.before.svg';
import { ReactComponent as MobilityStationsAfterImageComponent } from './images/concepts/effects/mobilityStations.after.svg';
import { ReactComponent as ParkingCarReducedBeforeImageComponent } from './images/concepts/effects/parkingCarReduced.before.svg';
import { ReactComponent as ParkingCarReducedAfterImageComponent } from './images/concepts/effects/parkingCarReduced.after.svg';
import { ReactComponent as CarSharingBeforeImageComponent } from './images/concepts/effects/carSharing.before.svg';
import { ReactComponent as CarSharingAfterImageComponent } from './images/concepts/effects/carSharing.after.svg';
import { ReactComponent as ParkingBikeIncreasedBeforeImageComponent } from './images/concepts/effects/parkingBikeIncreased.before.svg';
import { ReactComponent as ParkingBikeIncreasedAfterImageComponent } from './images/concepts/effects/parkingBikeIncreased.after.svg';
import { ReactComponent as BikeSwarmBeforeImageComponent } from './images/concepts/effects/bikeSwarm.before.svg';
import { ReactComponent as BikeSwarmAfterImageComponent } from './images/concepts/effects/bikeSwarm.after.svg';

import CityMp3Audio from './sounds/city.mp3';
import MusicMp3Audio from './sounds/music.mp3';
import CheckMp3Audio from './sounds/check.mp3';
import BubbleMp3Audio from './sounds/bubble.mp3';
import EnteringMp3Audio from './sounds/entering.mp3';
import PersonMovesMp3Audio from './sounds/person_moves.mp3';

import type { Aspect } from '../data/Score';
import type { Season } from '../data/Seasons';
import isString from 'lodash/isString';

type Filename = string;
export type ImageComponent = FunctionComponent<SVGProps<SVGSVGElement>>;
export type Image = Filename | ImageComponent;

export const isFilename = (image: Image): image is Filename => {
	return isString(image);
};

interface Images {
	map: Filename;
	close: ImageComponent;
	back: ImageComponent;
	next: ImageComponent;
	speechBubbleSmall: Filename;
	speechBubbleLarge: Filename;
	pointer: ImageComponent;
	checked: ImageComponent;
	plus: ImageComponent;
	settings: ImageComponent;
	volumeLow: ImageComponent;
	volumeHigh: ImageComponent;
	// Seasons
	spring: ImageComponent;
	summer: ImageComponent;
	fall: ImageComponent;
	winter: ImageComponent;
	// Score
	environment: ImageComponent;
	qualityOfLife: ImageComponent;
	happiness: ImageComponent;
	// Personas
	'narrator.body': ImageComponent;
	'narrator.interested.body': ImageComponent;
	'narrator.skeptical.body': ImageComponent;
	'narrator.amazed.body': ImageComponent;
	'narrator.amazed2.body': ImageComponent;
	'proponent.body': ImageComponent;
	'opponent.body': ImageComponent;
	'aische.face.positive': ImageComponent;
	'aische.face.negative': ImageComponent;
	'aische.body.positive': ImageComponent;
	'aische.body.negative': ImageComponent;
	'ben.face.positive': ImageComponent;
	'ben.face.negative': ImageComponent;
	'ben.body.positive': ImageComponent;
	'ben.body.negative': ImageComponent;
	'helga.face.positive': ImageComponent;
	'helga.face.negative': ImageComponent;
	'helga.body.positive': ImageComponent;
	'helga.body.negative': ImageComponent;
	'horst.face.positive': ImageComponent;
	'horst.face.negative': ImageComponent;
	'horst.body.positive': ImageComponent;
	'horst.body.negative': ImageComponent;
	'leon.face.positive': ImageComponent;
	'leon.face.negative': ImageComponent;
	'leon.body.positive': ImageComponent;
	'leon.body.negative': ImageComponent;
	'maxi.face.positive': ImageComponent;
	'maxi.face.negative': ImageComponent;
	'maxi.body.positive': ImageComponent;
	'maxi.body.negative': ImageComponent;
	'mel.face.positive': ImageComponent;
	'mel.face.negative': ImageComponent;
	'mel.body.positive': ImageComponent;
	'mel.body.negative': ImageComponent;
	'pete.face.positive': ImageComponent;
	'pete.face.negative': ImageComponent;
	'pete.body.positive': ImageComponent;
	'pete.body.negative': ImageComponent;
	'samira.face.positive': ImageComponent;
	'samira.face.negative': ImageComponent;
	'samira.body.positive': ImageComponent;
	'samira.body.negative': ImageComponent;
	// Concepts
	// Concepts - Icons
	'parkingCarReduced.icon': ImageComponent;
	'mobilityStations.icon': ImageComponent;
	'speedlimit20.icon': ImageComponent;
	'parkingBikeIncreased.icon': ImageComponent;
	'electricCarChargers.icon': ImageComponent;
	'coworking.icon': ImageComponent;
	'showers.icon': ImageComponent;
	'carSharing.icon': ImageComponent;
	'parkingShared.icon': ImageComponent;
	'parcelShops.icon': ImageComponent;
	'fishies.icon': ImageComponent;
	'bikeSwarm.icon': ImageComponent;
	// Concepts - Overlays
	'parkingCarReduced.overlay.active': Filename;
	'parkingCarReduced.overlay.inactive': Filename;
	'speedlimit20.overlay.active': Filename;
	'parkingBikeIncreased.overlay.active': Filename;
	'coworking.overlay.active': Filename;
	'showers.overlay.active': Filename;
	'parcelShops.overlay.active': Filename;
	'electricCarChargers.overlay.active': Filename;
	'mobilityStations.overlay.active': Filename;
	// Concepts - Effects
	'parkingCarReduced.before': ImageComponent;
	'parkingCarReduced.after': ImageComponent;
	'mobilityStations.before': ImageComponent;
	'mobilityStations.after': ImageComponent;
	'speedlimit20.before': ImageComponent;
	'speedlimit20.after': ImageComponent;
	'parkingBikeIncreased.before': ImageComponent;
	'parkingBikeIncreased.after': ImageComponent;
	'electricCarChargers.before': ImageComponent;
	'electricCarChargers.after': ImageComponent;
	'coworking.before': ImageComponent;
	'coworking.after': ImageComponent;
	'showers.before': ImageComponent;
	'showers.after': ImageComponent;
	'carSharing.before': ImageComponent;
	'carSharing.after': ImageComponent;
	'parkingShared.before': ImageComponent;
	'parkingShared.after': ImageComponent;
	'parcelShops.before': ImageComponent;
	'parcelShops.after': ImageComponent;
	'fishies.before': ImageComponent;
	'fishies.after': ImageComponent;
	'bikeSwarm.before': ImageComponent;
	'bikeSwarm.after': ImageComponent;
}

const IMAGES: Images = {
	map: MapSvgImage,
	close: CloseImageComponent,
	back: BackImageComponent,
	next: NextImageComponent,
	speechBubbleSmall: SpeechBubbleSmallSvgImage,
	speechBubbleLarge: SpeechBubbleLargeSvgImage,
	pointer: PointerImageComponent,
	checked: CheckedImageComponent,
	plus: PlusImageComponent,
	settings: SettingsImageComponent,
	volumeLow: VolumeLowImageComponent,
	volumeHigh: VolumeHighImageComponent,
	// Seasons
	spring: SpringImageComponent,
	summer: SummerImageComponent,
	fall: FallImageComponent,
	winter: WinterImageComponent,
	// Score
	environment: EnvironmentImageComponent,
	qualityOfLife: QualityOfLifeImageComponent,
	happiness: HappinessImageComponent,
	// Personas
	'narrator.body': EllenBodyImageComponent,
	'narrator.interested.body': EllenInterestedBodyImageComponent,
	'narrator.skeptical.body': EllenSkepticalBodyImageComponent,
	'narrator.amazed.body': EllenAmazedBodyImageComponent,
	'narrator.amazed2.body': EllenAmazed2BodyImageComponent,
	'proponent.body': ProponentBodyImageComponent,
	'opponent.body': OpponentBodyImageComponent,
	'aische.face.positive': AischeFacePositiveImageComponent,
	'aische.face.negative': AischeFaceNegativeImageComponent,
	'aische.body.positive': AischeBodyPositiveImageComponent,
	'aische.body.negative': AischeBodyNegativeImageComponent,
	'ben.face.positive': BenFacePositiveImageComponent,
	'ben.face.negative': BenFaceNegativeImageComponent,
	'ben.body.positive': BenBodyPositiveImageComponent,
	'ben.body.negative': BenBodyNegativeImageComponent,
	'helga.face.positive': HelgaFacePositiveImageComponent,
	'helga.face.negative': HelgaFaceNegativeImageComponent,
	'helga.body.positive': HelgaBodyPositiveImageComponent,
	'helga.body.negative': HelgaBodyNegativeImageComponent,
	'horst.face.positive': HorstFacePositiveImageComponent,
	'horst.face.negative': HorstFaceNegativeImageComponent,
	'horst.body.positive': HorstBodyPositiveImageComponent,
	'horst.body.negative': HorstBodyNegativeImageComponent,
	'leon.face.positive': LeonFacePositiveImageComponent,
	'leon.face.negative': LeonFaceNegativeImageComponent,
	'leon.body.positive': LeonBodyPositiveImageComponent,
	'leon.body.negative': LeonBodyNegativeImageComponent,
	'maxi.face.positive': MaxiFacePositiveImageComponent,
	'maxi.face.negative': MaxiFaceNegativeImageComponent,
	'maxi.body.positive': MaxiBodyPositiveImageComponent,
	'maxi.body.negative': MaxiBodyNegativeImageComponent,
	'mel.face.positive': MelFacePositiveImageComponent,
	'mel.face.negative': MelFaceNegativeImageComponent,
	'mel.body.positive': MelBodyPositiveImageComponent,
	'mel.body.negative': MelBodyNegativeImageComponent,
	'pete.face.positive': PeteFacePositiveImageComponent,
	'pete.face.negative': PeteFaceNegativeImageComponent,
	'pete.body.positive': PeteBodyPositiveImageComponent,
	'pete.body.negative': PeteBodyNegativeImageComponent,
	'samira.face.positive': SamiraFacePositiveImageComponent,
	'samira.face.negative': SamiraFaceNegativeImageComponent,
	'samira.body.positive': SamiraBodyPositiveImageComponent,
	'samira.body.negative': SamiraBodyNegativeImageComponent,
	// Concepts
	'parkingCarReduced.icon': ParkingCarReducedImageComponent,
	'mobilityStations.icon': MobilityStationsImageComponent,
	'speedlimit20.icon': Speedlimit20ImageComponent,
	'parkingBikeIncreased.icon': ParkingBikeIncreasedImageComponent,
	'electricCarChargers.icon': ElectricCarChargersImageComponent,
	'coworking.icon': CoworkingImageComponent,
	'showers.icon': ShowersImageComponent,
	'carSharing.icon': CarSharingImageComponent,
	'parkingShared.icon': ParkingSharedImageComponent,
	'parcelShops.icon': ParcelShopsImageComponent,
	'fishies.icon': FishiesImageComponent,
	'bikeSwarm.icon': BikeSwarmImageComponent,
	// Concepts - Overlays
	'parkingCarReduced.overlay.active': ParkingCarReducedActiveOverlaySvgImage,
	'parkingCarReduced.overlay.inactive':
		ParkingCarReducedInactiveOverlaySvgImage,
	'speedlimit20.overlay.active': Speedlimit20ActiveOverlaySvgImage,
	'parkingBikeIncreased.overlay.active':
		ParkingBikeIncreasedActiveOverlaySvgImage,
	'coworking.overlay.active': CoworkingActiveOverlaySvgImage,
	'showers.overlay.active': ShowersActiveOverlaySvgImage,
	'parcelShops.overlay.active': ParcelShopsActiveOverlaySvgImage,
	'electricCarChargers.overlay.active':
		ElectricCarChargersActiveOverlaySvgImage,
	'mobilityStations.overlay.active': MobilityStationsActiveOverlaySvgImage,
	// Concepts - Effects
	'parkingCarReduced.before': ParkingCarReducedBeforeImageComponent,
	'parkingCarReduced.after': ParkingCarReducedAfterImageComponent,
	'mobilityStations.before': MobilityStationsBeforeImageComponent,
	'mobilityStations.after': MobilityStationsAfterImageComponent,
	'speedlimit20.before': Speedlimit20BeforeImageComponent,
	'speedlimit20.after': Speedlimit20AfterImageComponent,
	'parkingBikeIncreased.before': ParkingBikeIncreasedBeforeImageComponent,
	'parkingBikeIncreased.after': ParkingBikeIncreasedAfterImageComponent,
	'electricCarChargers.before': ElectricCarChargersBeforeImageComponent,
	'electricCarChargers.after': ElectricCarChargersAfterImageComponent,
	'coworking.before': CoworkingBeforeImageComponent,
	'coworking.after': CoworkingAfterImageComponent,
	'showers.before': ShowersBeforeImageComponent,
	'showers.after': ShowersAfterImageComponent,
	'carSharing.before': CarSharingBeforeImageComponent,
	'carSharing.after': CarSharingAfterImageComponent,
	'parkingShared.before': ParkingSharedBeforeImageComponent,
	'parkingShared.after': ParkingSharedAfterImageComponent,
	'parcelShops.before': ParcelShopsBeforeImageComponent,
	'parcelShops.after': ParcelShopsAfterImageComponent,
	'fishies.before': FishiesBeforeImageComponent,
	'fishies.after': FishiesAfterImageComponent,
	'bikeSwarm.before': BikeSwarmBeforeImageComponent,
	'bikeSwarm.after': BikeSwarmAfterImageComponent
};

interface Sounds {
	city: Filename;
	music: Filename;
	check: Filename;
	bubble: Filename;
	entering: Filename;
	personMoves: Filename;
}

const SOUNDS: Sounds = {
	city: CityMp3Audio,
	music: MusicMp3Audio,
	check: CheckMp3Audio,
	bubble: BubbleMp3Audio,
	entering: EnteringMp3Audio,
	personMoves: PersonMovesMp3Audio
};

const ASSETS = {
	images: IMAGES,
	sounds: SOUNDS
};

type Assets = Readonly<typeof ASSETS>;

export type ImageKey = keyof Images | string;

export default ASSETS as Assets;

export const getImageByKey = (key: ImageKey): Image => {
	const image = ASSETS.images[key as keyof Images];
	if (!image) {
		throw new Error('Image not found: ' + key);
	}
	return image;
};

export const getImageComponentByKey = (key: ImageKey): ImageComponent => {
	const image = getImageByKey(key);
	if (isString(image)) {
		throw new Error('Image is not an image component: ' + key);
	}
	return image;
};

export const getMapOverlayImage = (key: ImageKey): Filename => {
	const filename = ASSETS.images[key as keyof Images];
	if (!filename) {
		throw new Error('Map overlay not found: ' + key);
	}
	if (!isString(filename)) {
		throw new Error('Map overlay must be an file: ' + key);
	}
	return filename;
};

export const getAspectImage = (aspect: Aspect): ImageComponent => {
	switch (aspect) {
		case 'environment':
			return IMAGES.environment;
		case 'happiness':
			return IMAGES.happiness;
		case 'qualityOfLife':
			return IMAGES.qualityOfLife;
	}
};

export const getSeasonImage = (season: Season): ImageComponent => {
	switch (season) {
		case 'spring':
			return IMAGES.spring;
		case 'summer':
			return IMAGES.summer;
		case 'fall':
			return IMAGES.fall;
		case 'winter':
			return IMAGES.winter;
	}
};
